import { Component, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';

@Component({
  standalone: false,
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  langData: any;

  constructor( public app: AppComponent ) {       
  }

  ngOnInit() {  
  }
}
